import { Grid, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useNotify, useTranslate } from 'react-admin'
import { billingServices } from 'src/services/reservation/billing/billing.service'

export const VisualizedInvoice = ({
        style = {},
        form,
        triggerVisualize,
        setLoadingVisualize,
        setTriggerVisualize
    }) => {
    const [invoiceData, setInvoiceDate] = useState(null)
    const notify = useNotify()
    const translate = useTranslate()

    useEffect(()=>{
        if (triggerVisualize) {
            previsualizeInvoice()
        }
    },[triggerVisualize])

    const previsualizeInvoice = async () =>{
        setLoadingVisualize(true)
        await billingServices.visualizeInvoice({...form, base:null}).then((res)=>{
            setInvoiceDate(res)
        }).catch(()=>{
            notify('ra.notification.visualize_invoice_error', {type:'error'})
        }).finally(()=>{
            setLoadingVisualize(false)
            setTriggerVisualize(false)
        })
    }

    if (!invoiceData) return null

    return (
        <Grid
            container
            spacing={3}
            style={{
                padding: 8,
                borderStyle:'solid',
                borderWidth:'1px',
                borderColor:'gray',
                borderRadius:'10px',
                ...style
            }}
        >
            {Object.entries(invoiceData).map(([field,value]) => (
                <Grid item xs={12} sm={6}>
                    <Typography style={{fontWeight:'bold'}}>
                        {`${translate(`ra.field.${field}`)}: `}
                    </Typography>
                    <Typography>
                        {
                            field === 'billing_status' || field === 'status' ?
                            translate(`ra.status.${value}`)
                            : value
                        }
                    </Typography>
                </Grid>
            ))}

        </Grid>
    )
}
